<template>
    <span>{{ display_value }}</span>
</template>

<script>
export default {
    name: "NumberDisplay",
    props: ["value", "decimals", "default"],
    computed: {
        display_value() {
            if (this.value) {
                let decimals = this.decimals;
                if (!decimals) {
                    decimals = 0;
                }

                return (+this.value).toFixed(decimals);
            }

            return this.default;
        },
    },
};
</script>

<style scoped></style>
